import { AbstractControl, FormArray, UntypedFormGroup, ValidationErrors } from '@angular/forms';

export interface AllValidationErrors {
  control_name: string;
  error_name: string;
  error_value: any;
}

export interface FormGroupControls {
  [key: string]: AbstractControl;
}


export function getFormValidationErrors(group: UntypedFormGroup | FormArray): AllValidationErrors[] {
  let errors: AllValidationErrors[] = [];
  Object.keys(group.controls).forEach(key => {
    const control = group.get(key);
    if (control instanceof UntypedFormGroup) {
      errors = errors.concat(getFormValidationErrors(control));
    }
    // 2. Safely access errors from the control we already found
    const controlErrors = control?.errors;
    
    if (controlErrors !== null) {
      Object.keys(controlErrors).forEach(keyError => {
        errors.push({
          control_name: key,
          error_name: keyError,
          // 3. Cast to any to ensure we can index the ValidationErrors object
          error_value: (controlErrors as any)[keyError]
        });
      });
    }
  });
  
  return errors;
}


export function updateTreeValidity(group: UntypedFormGroup | FormArray): void {
  Object.keys(group.controls).forEach((key: string) => {
    const abstractControl = group.get(key);

    if (abstractControl instanceof UntypedFormGroup || abstractControl instanceof FormArray) {
      updateTreeValidity(abstractControl);
    } else {
      abstractControl.updateValueAndValidity();
    }
  });
}